import React from 'react';
import { Box, Typography, Button } from '@mui/material';

const InstapathPilot = () => {
    return (
        <>
            <Box
                sx={{
                    padding: '32px 16px',
                    maxWidth: '1200px',
                    margin: '0 auto', // Center content on the page
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' }, // Stack on small screens, side-by-side on larger
                    alignItems: 'center',
                    gap: '24px',
                }}
            >
                {/* Left-Side Image */}
                <Box
                    component="img"
                    src="/mockup-iphone16-weather-home.png"
                    alt="Instapath Pilot Mobile App"
                    sx={{
                        width: { xs: '100%', md: '50%' },
                        maxWidth: '250px',
                        height: 'auto',
                        borderRadius: '8px',
                    }}
                />

                {/* Right-Side Content */}
                <Box
                    sx={{
                        flex: 1,
                        textAlign: 'left',
                        paddingLeft: '16px', // Add left padding
                    }}
                >
                    {/* Title Section */}
                    <Typography variant="h4" component="h1" gutterBottom>
                        Discover Instapath Pilot and Pilot Pro
                    </Typography>

                    {/* Description Section */}
                    <Typography variant="body1" gutterBottom>
                        The <strong>Instapath Pilot</strong> mobile app works seamlessly with the
                        <strong> Instapath.io</strong> website to streamline mission execution for pilots in the field.
                        Available as a free download, the app integrates with all <strong>Instapath.io</strong> plans.
                    </Typography>

                    {/* Instapath Pro Section */}
                    <Typography variant="h5" component="h2" gutterBottom sx={{ marginTop: '24px' }}>
                        Unlock More with Instapath Pilot Pro
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        Upgrade the mobile app to <strong>Pilot Pro</strong> (via an in-app purchase) to access extra
                        features designed for advanced mission planning and execution.
                    </Typography>

                    {/* How It Works Section */}
                    <Typography variant="h5" component="h2" gutterBottom sx={{ marginTop: '24px' }}>
                        How It Works
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        1. Sign up on this website and subscribe to the <strong>Pro</strong> plan.
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        2. In the <strong>Personnel</strong> section, add your mobile user by entering their email address. Ensure it matches their Instapath Pilot account for seamless integration.
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        3. Once added, pilots’ data will sync seamlessly across platforms.
                    </Typography>

                    {/* Call to Action */}
                    <Box sx={{ marginTop: '32px' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            href="/platform/mobile"
                            sx={{ textTransform: 'none', fontWeight: 'bold' }}
                        >
                            Learn More About Instapath Pilot
                        </Button>
                    </Box>
                </Box>
            </Box>
        </>
    );
};

export default InstapathPilot;